import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { TipoGastosService } from '../../tipo-gastos/tipo-gastos.service';
import { GastosService } from '../gastos.service';
@Component({
  selector: 'app-gastos-view',
  templateUrl: './gastos-view.component.html',
  styleUrls: ['./gastos-view.component.scss']
})
export class GastosViewComponent implements OnInit {

  @Input() element: any = {}
  form: FormGroup = new FormGroup({});
  select_Tgastos: Array<any> = [];
  selected!: number;
  constructor(
    public formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private loading: LoadingService,
    private alerts: AlertService,
    public formatter: FormatterService,
    public _service: TipoGastosService
  ) { }

  ngOnInit(): void {

    this.select()
    this.form = this.formBuilder.group({
      fecha: ['', Validators.required],
      monto: ['', Validators.required],
      detalle: [''],
      tipo_gasto_id: ['', Validators.required]
    })

    this.form.patchValue({
      ...this.element,
      fecha: this.element.fecha.substring(0, 10),
      monto: '$ ' + this.formatter.numberFormat(this.element.monto),
      tipo_gasto_id: this.element.tipo_gasto.nombre
    })
    this.form.disable()
  }

  select() {
    this.loading.show()
    let user = JSON.parse(localStorage.getItem('usuario') as string);
    this._service.select(user).subscribe({
      next: (res) => {
        this.loading.hide();
        this.select_Tgastos = res
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo cargar lost tipos de gastos de la empresa.", "danger");
        console.log(err.error.response)
        if (err.error.response) {
          this.alerts.addAlert(err.error.response, "danger");
        }
      }
    })
  }
}
